module.exports = __webpack_public_path__ + "static/media/hanakawado-asakusa-5.8ddb4602.jpg";